import React from 'react'
import { Footer } from '../components/common/Footer/Footer'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import logger from '../utils/logger'


// export const PublicLayout = () => {

//     const authStatus = useSelector((state) => state.enableRoute.valor)
//     logger.debug('PublicLayout authStatus: ', authStatus)
//     return (

//         (authStatus !== 'authorized' ?
//             <>
//                 <Outlet />

//                 <Footer />
//             </>
//             :
//             <Navigate to="/member" />
//         )

//     )
// }


export const PublicLayout = () => (
  <>
    <Outlet />
    <Footer />
  </>
)
